import React from 'react';

import { expVal } from '@confluence/feature-experiments';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

const RoleBasedAccessControlHubRouteComponent = LoadablePaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-RoleBasedAccessControlHubRoute" */ './RoleBasedAccessControlHubRouteComponent.tsx'
		),
});

export const RoleBasedAccessControlHubRoute = () => {
	if (!expVal('confluence_rbac_pre_planning_release_fe', 'isEnabled', false)) {
		return <Redirection name={HOME.name} />;
	}
	return <RoleBasedAccessControlHubRouteComponent />;
};

RoleBasedAccessControlHubRoute.NAVIGATION_PARAMS = (routeMatch: RouteMatch) => {
	const { name } = routeMatch;

	return {
		Screen: {
			screenEvent: {
				name: 'roleBasedAccessControlHubScreen',
			},
			pageState: { routeName: name },
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
